import { useState, useEffect, cloneElement } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getClasses } from "../../../ApiService/ApiService";
import ClassesTable from "./ClassesTable";
import AddClass from "./AddClass";
import { Add } from "@mui/icons-material";

function ClassesSection() {
  const [classes, setClasses] = useState({});
  const [showAddClass, setShowAddClass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [actionComponent, setActionComponent] = useState(null);

  useEffect(() => {
    fetchClasses();
  }, []);

  const fetchClasses = async () => {
    try {
      setLoading(true);
      const response = await getClasses();
      setClasses(response?.data);
    } catch (err) {
      console.error("Error fetching classes:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleActionClick = (actionComponent, classId, schoolId) => {
    setActionComponent(cloneElement(actionComponent, { classId, schoolId }));
  };

  const renderMainContent = () => {
    if (showAddClass) {
      return (
        <AddClass
          fetchClasses={fetchClasses}
          setShowAddClass={setShowAddClass}
        />
      );
    } else if (actionComponent) {
      return <Box>{actionComponent}</Box>;
    } else {
      return (
        <ClassesTable
          classes={classes}
          fetchClasses={fetchClasses}
          setActionComponent={setActionComponent}
          handleActionClick={handleActionClick}
        />
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddClass || actionComponent ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{
            fontWeight: 600,
            fontSize: 22,
            fontFamily: "Barlow, sans-serif",
          }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Classes
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddClass(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" /> Add Class
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default ClassesSection;
